import {
  HOME_START_SCHEDULING_BEGIN,
  HOME_START_SCHEDULING_SUCCESS,
  HOME_START_SCHEDULING_FAILURE,
  HOME_START_SCHEDULING_DISMISS_ERROR,
} from './constants';

import {makeDictionary} from '../../common/util'
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function startScheduling(schedule, finePlanning, additionalTours) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_START_SCHEDULING_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
       let actionName = finePlanning ? "RunFineScheduling" : additionalTours ? "RunTourPlanning" :"RunCoarseScheduling";
       axios.post("/api/Scheduling/"+schedule.id+"/"+actionName,{id: schedule.id,
        seasonId:schedule.seasonId,
        description: schedule.description,
        creation: schedule.creation,
        scheduleAssignments: schedule.scheduleAssignments,
        additionalTours
      }).then(
        (res) => {
          dispatch({
            type: HOME_START_SCHEDULING_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_START_SCHEDULING_FAILURE,
            data: { error: err },
          });
          
        },
      );
    });

    return promise;
  };
}

export function cancelPendingScheduling() {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_START_SCHEDULING_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
       
       axios.post("/api/Scheduling/CancelPendingSchedules"
      ).then(
        (res) => {
          dispatch({
            type: HOME_START_SCHEDULING_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_START_SCHEDULING_FAILURE,
            data: { error: err },
          });
          
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissStartSchedulingError() {
  return {
    type: HOME_START_SCHEDULING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_START_SCHEDULING_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        startSchedulingPending: true,
        startSchedulingError: null,
      };

    case HOME_START_SCHEDULING_SUCCESS:
      // The request is success

      let updatedSchedules = makeDictionary(action.data.schedules);

      return {
        ...state,
        schedules:
        {
          ...state.schedules,
          ...updatedSchedules
        },
        startSchedulingPending: false,
        startSchedulingError: null,
      };

    case HOME_START_SCHEDULING_FAILURE:
      // The request is failed
      return {
        ...state,
        startSchedulingPending: false,
        startSchedulingError: action.data.error,
      };

    case HOME_START_SCHEDULING_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        startSchedulingError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/startScheduling.js